// Period presets & helpers for financial reports
export function periodRange(preset) {
  const now = new Date();
  const y = now.getFullYear();
  const m = now.getMonth();
  const startOfMonth = (yr, mo) => new Date(yr, mo, 1);
  const endOfMonth = (yr, mo) => new Date(yr, mo + 1, 0);
  const fmt = (d) => d.toISOString().slice(0, 10);
  switch (preset) {
    case "this_month":
      return { from: fmt(startOfMonth(y, m)), to: fmt(endOfMonth(y, m)), label: "Bulan Ini" };
    case "last_month":
      return { from: fmt(startOfMonth(y, m - 1)), to: fmt(endOfMonth(y, m - 1)), label: "Bulan Lalu" };
    case "q1":
      return { from: `${y}-01-01`, to: `${y}-03-31`, label: `Q1 ${y}` };
    case "q2":
      return { from: `${y}-04-01`, to: `${y}-06-30`, label: `Q2 ${y}` };
    case "q3":
      return { from: `${y}-07-01`, to: `${y}-09-30`, label: `Q3 ${y}` };
    case "q4":
      return { from: `${y}-10-01`, to: `${y}-12-31`, label: `Q4 ${y}` };
    case "ytd":
      return { from: `${y}-01-01`, to: fmt(now), label: `YTD ${y}` };
    case "last_year":
      return { from: `${y - 1}-01-01`, to: `${y - 1}-12-31`, label: `Tahun ${y - 1}` };
    case "all":
    default:
      return { from: "", to: "", label: "Semua Periode" };
  }
}

export const PERIOD_OPTIONS = [
  { key: "all", label: "Semua Periode" },
  { key: "this_month", label: "Bulan Ini" },
  { key: "last_month", label: "Bulan Lalu" },
  { key: "q1", label: "Q1 (Jan-Mar)" },
  { key: "q2", label: "Q2 (Apr-Jun)" },
  { key: "q3", label: "Q3 (Jul-Sep)" },
  { key: "q4", label: "Q4 (Okt-Des)" },
  { key: "ytd", label: "Year-to-Date" },
  { key: "last_year", label: "Tahun Lalu" },
  { key: "custom", label: "Custom" },
];

export function buildQuery(from, to) {
  const p = [];
  if (from) p.push(`from_date=${from}`);
  if (to) p.push(`to_date=${to}`);
  return p.length ? `?${p.join("&")}` : "";
}
